import '@adornis/file-utils/db/index.js';
import './ContactRequest.js';
import './api/index.js';

import '@chancenwerk/_buildify/wiki/entities/WikiEntry.js';
import '@chancenwerk/campus-learning-content/api/LearningDataAPI.js';
import '@chancenwerk/comments/index.js';
import '@chancenwerk/documentations/api/DocumentationAPI.js';
import '@chancenwerk/master-data-management/partner/index.js';
import '@chancenwerk/reporting/index.js';
import '@chancenwerk/user-configs/entities/EditUIConfig.js';
import '@chancenwerk/workshops/index.js';

import '@adornis/field-management/field-configuration.js';

import './AcquisitionRecord.js';
import './CRMFlags.js';
import './CampusMails.js';
import './CampusUserGroup.js';
import './DocxTemplate.js';
import './DuplicateDataTracker.js';
import './Holiday.js';
import './LogistikCart.js';
import './LogistikClearanceSettings.js';
import './LogistikInfoMail.js';
import './LogistikOrder.js';
import './LogistikProduct.js';
import './LogistikProductFilter.js';
import './LogistikProductOrdering.js';
import './OrAspect.js';
import './PresenceRecord.js';
import './ProductIdea.js';
import './RegisterEventlog.js';
import './ScopedEntity.js';
import './Scopes.js';
import './SoftgardenImportRecord.js';
import './StudentsReport.js';
import './capacity/index.js';
import './counters.js';

// Courses
import './courses/Course.js';
import './courses/CourseAbschluss.js';
import './courses/CourseChancenschule.js';
import './courses/CourseDigital.js';
import './courses/CourseGraduation.js';
import './courses/CourseIntensive.js';
import './courses/CourseIntensiveSingle.js';
import './courses/CourseLUS.js';
import './courses/CourseLernfoerderung.js';

import './dataTransferObjects/CRMActionResponse.js';
import './dataTransferObjects/FundingCreationInformation.js';
import './enums/enums.js';
import './eventlogs/AnmeldungConversionEventlog.js';
import './eventlogs/AttendanceExportEventlog.js';
import './eventlogs/ChancenKurveEventlog.js';
import './eventlogs/ChancencornerLessonFinishedEventlog.js';
import './eventlogs/ContentResultEventlog.js';
import './eventlogs/GuestDayEventlog.js';
import './eventlogs/MailEventlog.js';
import './eventlogs/PageLoadEventlog.js';
import './eventlogs/XAPIEventlog.js';
import './filter/StudentFilter.js';
import './import-export/employees.js';
import './import-export/student.js';
import './notifications/CampusNotification.js';
import './notifications/ChancenNotification.js';
import './semantics/ChancenRole.js';
import './semantics/ChancenRoleAspect.js';
import './semantics/ChancenRoleMultiAspect.js';
import './semantics/ExternalKPFRelationship.js';
import './semantics/PartnerRelationship.js';
import './semantics/SemanticRelationship.js';
import './semantics/StudentParticipationRelationship.js';
import './semantics/Taetigkeit.js';
import './tokens.js';

// Import api definitions for schema generation
// legacy this should be removed
// import '@chancenwerk/db';

import '@chancenwerk/export-dv/export-data-view.js';

import '@adornis/analytics/db/index.js';
import '@adornis/buildify/db/index.js';
import '@adornis/data-view/db/export-data-view.js';
import '@adornis/filter/get-standard-filter-operation.js';

import '@adornis/duplicate-merger/db/index.js';
import '@adornis/file-utils/db/index.js';
import '@adornis/filter/filter-options.js';
import '@adornis/import-export/db/export-job.js';
import '@adornis/import-export/db/import-job.js';
import '@adornis/print/db/print.js';
import '@adornis/todo/db/index.js';

// Import chancenwerk specific baseql definitions
import '@chancenwerk/_buildify/index.js';
import '@chancenwerk/_cms/index.js';
import '@chancenwerk/address/index.js';
import '@chancenwerk/attendance/index.js';
import '@chancenwerk/campus-learning-content/index.js';
import '@chancenwerk/family/index.js';
import '@chancenwerk/funding/index.js';
import '@chancenwerk/kpi/index.js';
import '@chancenwerk/markt/index.js';
import '@chancenwerk/master-data-management/index.js';
import '@chancenwerk/poll/index.js';
import '@chancenwerk/public-access/index.js';
import '@chancenwerk/release-notes/index.js';
import '@chancenwerk/secure-access/index.js';
import '@chancenwerk/user-configs/index.js';
import '@chancenwerk/view-manager/index.js';
import '@chancenwerk/work-tracking/index.js';

// Wiki
import '@adornis/view-manager/db';
import '@adornis/wiki/api';
import '@adornis/wiki/db';
import '@adornis/mails/db/mail-template.js';
